<template>

<div>

	<material-category
		:category="mutatedCategories"
		v-on:newCategory="newCategory"
		v-on:saveCategory="saveCategory"
		v-on:deleteCategory="deleteCategory"
		:is-static="true">
	</material-category>

</div>

</template>

<script type="text/javascript">

import MaterialCategory from "./MaterialCategory";

export default {
	name: "MaterialCategoryTree",
	props: [
		"value"		// List of material categories
	],
	components: {
		MaterialCategory
	},
	data() {
		return {

			localCategories: null,
			pathDelimiter: '\\\\'

		}
	},

	watch: {
		value() {
			this.localCategories = this.cloneObj(this.value)
		}
	},

	computed: {

		mutatedCategories() {

			if (!this.localCategories)
				return []

			let categoryTree = this.groupRecords(this.localCategories, 'category_id')
			this.generatePaths(categoryTree, '')

			return {
				name: "All Categories",
				children: categoryTree,
			}
		},

	},

	methods: {

		addToCategoryList(cat) {
			this.localCategories.push(cat)
			this.$emit('input', this.localCategories)
		},

		removeFromCategoryList(catId) {
			let index = this.localCategories.findIndex(cat => cat.id == catId)
			this.alertSuccess("'" + this.localCategories[index].name + "' has been deleted")
			this.localCategories.splice(index, 1)
			this.$emit('input', this.localCategories)
		},

		modifyCategory(cat, newFields) {
			Object.keys(newFields).forEach(field => {
				if (field in cat && field != 'id' && field != 'slug')
					cat[field] = newFields[field]
			})

			this.$emit('input', this.localCategories)
		},

		newCategory(payload) {
			let vm = this

			this.postData("MaterialCategory/save", payload).then(response => {

				if (response.success) {

					vm.getJSON("MaterialCategory/find/"+response.data.record_id).then(resp => {
						vm.addToCategoryList(resp.data)
					})
				}
			})
		},

		saveCategory(payload) {
			let vm = this

			this.postData("MaterialCategory/save", payload).then(response => {
				if (response.success) {

					let category = vm.localCategories.find(cat => cat.id == response.record_id)

					if ('name' in category && 'name' in payload)
						vm.alertSuccess("'" + category.name + "' has been changed to '"+payload.name+"'")

					vm.modifyCategory(category, payload)
				}
			})
		},

		deleteCategory(id) {
			let vm = this

			this.postData("MaterialCategory/delete", {id}).then(response => {

				if (response.deleted_records) {
					vm.removeFromCategoryList(id)

				} else {
					vm.alertFail("'" + vm.category.name + "' could not be deleted")
				}
			})
		},

		generatePaths(cats, parentPath) {
			cats.forEach(cat => {
				cat.path = (parentPath.length) ? parentPath.concat(this.pathDelimiter, cat.name) : cat.name
				if ('children' in cat && cat.children.length)
					this.generatePaths(cat.children, cat.path)
			})
		},

		fetchCategories() {

			this.getJSON("MaterialCategory/get").then(response => {
				if (response.success) {
					this.localCategories = response.data
				}
			})
		}
	},

	created() {
		if (!this.value) {
			this.fetchCategories()
		} else {
			this.localCategories = this.cloneObj(this.value)
		}
	}
}
</script>

<style scoped>

</style>